// extracted by mini-css-extract-plugin
export default {"root":"CircularProgress_root__GpAWZ","rotate":"CircularProgress_rotate__RNFM7","dash":"CircularProgress_dash__7ZoDi"};